<template>
  <div class="fail-wrap">
    <div class="result-area">
      <div class="result-contents">
        <img
          alt="앗"
          height="80"
          src="data:image/png;base64,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"
          width="66"
        />
        <div class="message">
          <p>주문을 완료하지 못했습니다</p>
          <p class="caution">{{ errorMessage }}</p>
        </div>
      </div>
      <div class="result-footer">
        <img
          alt
          height="200"
          src="~@/presentationals/v1/assets/images/order_cancel.gif"
          style="align-self: center"
          width="200"
        />
        <div class="btn-area">
          <button @click="goHome()" class="btn-primary btn-home" type="button">
            홈으로 돌아가기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFail',
  data() {
    return {
      errorMessage: ''
    }
  },
  created() {
    this.errorMessage = this.$route.query.message
    this.redirect = this.$route.query.redirect
    if (!this.isAndroid && this.redirect !== 'true') {
      let url = new URL(window.location.href)
      url.searchParams.append('redirect', 'true')
      window.location.replace(
        `${process.env.VUE_APP_IOS_ORDER_FAIL_URL}${encodeURIComponent(url.toString())}`
      )
    }
  },
  computed: {
    isAndroid() {
      return this.$store.getters.isAndroid()
    }
  },
  methods: {
    goHome() {
      window.location.replace(`${process.env.VUE_APP_HOME_URL}`)
    }
  }
}
</script>

<style>
.fail-wrap {
  display: flex;
  width: 100%;
  height: 100%;
}
</style>

<style scoped>
.result-area {
  width: 100%;
  padding: 48px 16px 15px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

.result-contents {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.result-footer {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-self: flex-end;
}

.message {
  margin-top: 18px;
  font-size: 18px;
  line-height: 1.39;
  letter-spacing: -0.5px;
  text-align: center;
}

.caution {
  color: #f52926;
}
</style>
